import SMSCode from './SMSCode'

export default SMSCode
